// extracted by mini-css-extract-plugin
export default {"titleBox":"favorites_titleBox__a9uZI","container":"favorites_container__ZlUEM","productBox":"favorites_productBox__TZTNR","filterBox":"favorites_filterBox__UP0Bf"};